import React, {useEffect, useState} from "react";
import {notification, Radio} from "antd";
import {Col, Form, Row} from "react-bootstrap";
import "./journals.scss";
import TextInput from "../../../components/common/input-field/TextInput";
import {checkEmptySpaces, maxLength, Required} from "../../../utils/patterns";
import {Controller, useForm} from "react-hook-form";
import {useNavigate} from "react-router";
import ThemeButton from "../../../components/common/theme-button/ThemeButton";
import {DropDownCheck, RoundedCheck,} from "../../../../assets/icons/defaultIcons";
import DescriptionField from "../../../components/common/description-field/DescriptionField";
import {QuestionService} from "../../../services/questions-api.service";
import {JournalService} from "../../../services/journals-api.service";
import JournalsSkeleton from "../../skeletons/journals/JournalsSkeleton";
import {useJournal} from "../../../providers/JournalContext";
import AllJournals from "./AllJournals";

export default function Journals() {
  const [value1, setValue1] = useState("free-flow");
  const [loader, setLoader] = useState(true);
  const [questionReFrame, setQuestionReFrame] = useState({});
  const [questionFreeFlow, setQuestionFreeFlow] = useState({});
  const [questionDevotional, setQuestionDevotional] = useState({});
  const [questionType, setQuestionType] = useState("re-frame");
  const [allJournals, setAllJournals] = useState(null);
  const [selectedItem, setSelectedItem] = useState("All");
  const [listing, setListing] = useState(false);
  const [passwordModal, setPasswordModal] = useState(true);
  const navigate = useNavigate();
  const { validateJournalPass, setValidateJournalPass, firstTimePassword } =
    useJournal();
  const {
    handleSubmit,
    formState: { errors },
    control,
    reset,
    getValues,
  } = useForm({
    mode: "onChange",
  });

  async function GetJournals(type) {
    setLoader(true);
    const response = await JournalService.getJournal(type);
    if (response?.data?.data?.status) {
      setAllJournals(response?.data?.data?.data?.result);
      setLoader(false);
    }
  }

  async function GetReFrameQuestion(payload) {
    setLoader(true);
    const response = await QuestionService.getQuestion(payload);
    // console.log(response?.data?.data?.data, 're framequestion data')
    if (response?.data?.status) {
      setQuestionReFrame(response?.data?.data?.data[0]);
      // console.log(questionReFrame, 're frame ques')
      setLoader(false);
    }
  }

  async function GetFreeFlowQuestion(payload) {
    setLoader(true);
    const response = await QuestionService.getQuestion(payload);
    // console.log(response?.data?.data?.data, 're framequestion data')
    if (response?.data?.status) {
      setQuestionFreeFlow(response?.data?.data?.data[0]);
      setLoader(false);
    }
  }

  async function GetDevotionalQuestion(payload) {
    setLoader(true);
    const response = await QuestionService.getQuestion(payload);
    // console.log(response?.data?.data?.data, 're framequestion data')
    if (response?.data?.status) {
      setQuestionDevotional(response?.data?.data?.data[0]);
      setLoader(false);
    }
  }

  useEffect(() => {
    const payload = {
      type: "re-frame",
    };
    GetReFrameQuestion(payload);
  }, []);

  useEffect(() => {
    const payload = {
      type: "free-flow",
    };
    GetFreeFlowQuestion(payload);
  }, []);

  useEffect(() => {
    const payload = {
      type: "devotional",
    };
    GetDevotionalQuestion(payload);
  }, []);

  useEffect(() => {
    if (selectedItem !== "All") {
      GetJournals(selectedItem);
    } else {
      GetJournals("");
    }
  }, [selectedItem, listing]);

  // Get the questions based on the selected type
  const selectedQuestions =
    questionType === "re-frame"
      ? questionReFrame
      : questionType === "free-flow"
      ? questionFreeFlow
      : questionType === "devotional"
      ? questionDevotional
      : null;

  const onSubmit = async (data) => {
    const contentArray = [];
    setLoader(true);

    // Check if selectedQuestions is not null and has multiQuestions array
    if (selectedQuestions && selectedQuestions.multiQuestions) {
      selectedQuestions.multiQuestions.forEach((question, index) => {
        const questionValue = getValues(`question${index}`);
        if (questionValue) {
          contentArray.push({
            label: question,
            text: questionValue,
          });
        }
      });
    }

    // Construct the payload using the content array and selected type
    const payload = {
      questionId: selectedQuestions._id, // Assuming questionReFrame is an array and you want to use the ID of the first question
      content: contentArray,
      type: questionType,
    };

    // Loop through each question and construct the content object
    // questionReFrame?.multiQuestions?.forEach((question, index) => {
    //     const questionValue = getValues(`question${index}`); // Get value of the question input field
    //     if (questionValue) {
    //         // Only include content if the input field is not empty
    //         contentArray.push({
    //             label: question,
    //             text: questionValue,
    //         });
    //     }
    // });

    // Construct the payload using the first question ID and the content array
    // const payload = {
    //     questionId: questionReFrame._id, // Assuming questionReFrame is an array and you want to use the ID of the first question
    //     content: contentArray,
    //     type: 're-frame'
    // };

    const response = await JournalService.createJournal(payload);

    if (response?.data?.data?.status) {
      notification.success({
        message: "Success",
        description: response?.data?.data?.message,
        placement: "topRight",
        icon: <RoundedCheck />,
        duration: 2,
      });
      setListing(!listing);
      setLoader(false);
      reset();
      navigate(
        `/journals/details/${response.data?.data?.data?.result?.insertedId}`
      );
    }
    // else{
    //     notification.error({
    //         message: "Failed",
    //         description:  response?.data?.data?.message,
    //         placement: "topRight",
    //         icon: <CloseRoundedCheck/>,
    //         duration: 2,
    //     });
    //     setLoader(false)
    // }
    // console.log(data,'journal submit data data')
  };

  const options = [
    {
      label: "Free Flow",
      value: "free-flow",
    },
    {
      label: "Re-Frame",
      value: "re-frame",
    },
    {
      label: "Devotional",
      value: "devotional",
    },
  ];

  const onChange1 = ({ target: { value } }) => {
    setQuestionType(value);
    setValue1(value);
  };

  const items = [
    {
      key: "1",
      label: (
        <a
          onClick={() => {
            setSelectedItem("All");
          }}
          className={"d-flex justify-content-between w-100"}
        >
          All{" "}
          {selectedItem === "All" && (
            <span>
              <DropDownCheck />
            </span>
          )}
        </a>
      ),
    },
    {
      key: "2",
      label: (
        <a
          onClick={() => {
            setSelectedItem("free-flow");
          }}
          className={"d-flex justify-content-between w-100"}
        >
          Free Flow{" "}
          {selectedItem === "free-flow" && (
            <span>
              <DropDownCheck />
            </span>
          )}
        </a>
      ),
    },
    {
      key: "3",
      label: (
        <a
          onClick={() => {
            setSelectedItem("re-frame");
          }}
          className={"d-flex justify-content-between w-100"}
        >
          Re Frame{" "}
          {selectedItem === "re-frame" && (
            <span>
              <DropDownCheck />
            </span>
          )}
        </a>
      ),
    },
    {
      key: "4",
      label: (
        <a
          onClick={() => {
            setSelectedItem("devotional");
          }}
          className={"d-flex justify-content-between w-100"}
        >
          Devotional{" "}
          {selectedItem === "devotional" && (
            <span>
              <DropDownCheck />
            </span>
          )}
        </a>
      ),
    },
  ];

  // if (firstTimePassword) {
  //   navigate("/journals/set-journal-password");
  // }
  if (validateJournalPass) {
    navigate("/journals/validate-password");
  }

  useEffect(() => {
    // if (firstTimePassword === true) {
    //   navigate("/journals/set-journal-password");
    // }
    if (validateJournalPass === true) {
      navigate("/journals/validate-password");
    }
  }, [validateJournalPass]);



  if (loader) {
    return <JournalsSkeleton />;
  }

  return (
    <div className={"journals"}>
      {!loader && !validateJournalPass && (
        <Row>
          <Col md={12} lg={12} xl={8}>
            <div className={"type"}>
              <h4>Select Type</h4>
              <Radio.Group
                options={options}
                onChange={onChange1}
                value={value1}
              />
            </div>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className={"create-events"}>
                {value1 === "free-flow" && (
                    <Row>
                      <Col md={12}>
                        {questionFreeFlow?.multiQuestions?.map((item, index) => {
                          return (
                              <Col md={12} key={index}>
                                <div className={"dfields"}>
                                  <Controller
                                      name={`question${index}`}
                                      defaultValue={""}
                                      control={control}
                                      rules={{
                                        required: Required,
                                        maxLength: maxLength(10000),
                                        validate: checkEmptySpaces,
                                      }}
                                      render={({ field: { name, ...field } }) => (
                                          <DescriptionField
                                              label={item}
                                              placeholder={"Write your text here"}
                                              type={"text"}
                                              defaultValue={field.value}
                                              field={field}
                                              errors={errors[`question${index}`]}
                                              className={"required"}
                                              autoSize={{ minRows: 18, maxRows: 18 }}
                                          />
                                      )}
                                  />
                                </div>
                              </Col>
                          );
                        })}
                      </Col>
                    </Row>
                )}

                {value1 === "re-frame" && (
                  <Row>
                    {questionReFrame?.multiQuestions?.map((item, index) => {
                      return (
                        <Col md={12} key={index}>
                          <div className={"dfields"}>
                            <Controller
                              name={`question${index}`}
                              defaultValue={""}
                              control={control}
                              rules={{
                                validate: checkEmptySpaces,
                                required: Required,
                                maxLength: maxLength(10000),
                              }}
                              render={({ field: { name, ...field } }) => (
                                <TextInput
                                  placeholder={"Write your text here"}
                                  label={item}
                                  type={"text"}
                                  field={field}
                                  errors={errors[`question${index}`]}
                                  className={"required"}
                                />
                              )}
                            />
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                )}


                {value1 === "devotional" && (
                  <Row>
                    <Col md={12}>
                      {questionDevotional.multiQuestions?.map((item, index) => {
                        return (
                          <Col md={12} key={index}>
                            <div className={"dfields"}>
                              <Controller
                                name={`question${index}`}
                                defaultValue={""}
                                control={control}
                                rules={{
                                  required: Required,
                                  maxLength: maxLength(10000),
                                  validate: checkEmptySpaces,
                                }}
                                render={({ field: { name, ...field } }) => (
                                  <DescriptionField
                                    label={item}
                                    placeholder={"Write your text here"}
                                    type={"text"}
                                    defaultValue={field.value}
                                    field={field}
                                    errors={errors[`question${index}`]}
                                    className={"required"}
                                    autoSize={{ minRows: 18, maxRows: 18 }}
                                  />
                                )}
                              />
                            </div>
                          </Col>
                        );
                      })}
                    </Col>
                  </Row>
                )}

                <Row>
                  <Col md={12}>
                    {/*<div className={''}>*/}
                    {/*    <p className={'form-mess'}>May take 1 or more minutes for journal entries to show up. Do not enter twice.</p>*/}
                    {/*</div>*/}
                    <div className={"d-flex flex-column"}>
                      <ThemeButton
                        type={"Submit"}
                        text={"Submit"}
                        className={"btn-light-lg mt-3"}
                        loader={loader}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </Form>
          </Col>
          <Col className={"mt-4 mt-xl-0"} md={12} lg={12} xl={4}>
            <AllJournals/>
          </Col>
        </Row>
      )}
    </div>
  );
}
